<div #modalBaseDiv
     aria-hidden="true"
     class="modal {{ modalBaseClass || '' }}"
     role="dialog"
     [ngClass]="{show: open}"
     [ngStyle]="{'display': open ? 'block' : 'none'}">
    <div class="modal-dialog" [ngClass]="extraModalClasses">
        <div class="modal-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>
